import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import { useLocation } from 'react-router-dom';
import { getProfileMenuItems } from 'utils/profile';
import { HomeContext } from 'contexts/home/context';

const ProfileTabs = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { state } = useContext(HomeContext);
  const { userAccess } = state;
  const { allowedToViewCard } = userAccess ?? {};

  const profileMenuItems = getProfileMenuItems(!!allowedToViewCard, t);
  // substring to remove the forward slash of the path i.e. "/profile"
  return <Menu mode="horizontal" items={profileMenuItems} selectedKeys={[pathname.substring(1)]} />;
};

export default ProfileTabs;
